import type { ReactNode } from 'react';

export const symbol_add_triangle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M118-160q-26.38 0-39.19-22.5Q66-205 79-228l362-625q6.72-11 17.16-16.5 10.45-5.5 21.65-5.5 11.19 0 21.78 5.5Q512.19-864 519-853l362 625q13 23 .19 45.5T842-160H118Zm26-60h672L480-800 144-220Zm306-163v53q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-53h54q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5h-54v-54q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v54h-54q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h54Zm30-30Z"
		/>
	</svg>
);
